import { useState } from "react";
import ReactModal from "react-modal";
import useKeypress from "../ownHooks/pressEsc";
import { evuHeader, evuInputs } from "../Tabellen/ConstTabKopf/EvuKopf";
import { MyCancelButton, MyNewButton, MySaveButton } from "../StyleSheets/GeneralButtonStyles";
import { MyModalButtons, MyModalCloseButton, MyModalContentRow, MyModalContentTextInput, MyModalForm } from "../StyleSheets/ModalStyle";
import { FehlerauswertungErrResp } from "../Fehler/FehlerauswertungErrResp";

var MonitorApi = require('monitor-api');

export default function EvuCreate({ instance, reloadData }) {
    const attributes = evuHeader.filter(entry => evuInputs.includes(entry.accessor));
    const [newEvu, setNewEvu] = useState(new MonitorApi.EisenbahnverkehrsunternehmenCreate());
    const [showModal, setShowModal] = useState(false);

    useKeypress('Escape', () => {
        closeModal();
    });

    const openModal = () => {
        setNewEvu(new MonitorApi.EisenbahnverkehrsunternehmenCreate());
        setShowModal(true);
    }

    const closeModal = () => {
        setShowModal(false);
    }

    const changingInput = event => {
        event.preventDefault();
        setNewEvu(previous => ({ ...previous, [event.target.name]: event.target.value }))
    }

    const submitForm = event => {
        event.preventDefault();
        let creating = new Promise((resolve) => {
            instance.createEvuEisenbahnverkehrsunternehmenPost(newEvu, (error, data, response) => {
                if (error) {
                    FehlerauswertungErrResp(error, response);
                    resolve(error);
                } else {
                    alert(`Neues Eisenbahnverkehrsunternehmen ${data.name} hinzugefügt.\nMit id: ${data.id}`);
                    resolve(data);
                }
            })
        })
        creating.then((msg) => {
            closeModal();
            reloadData();
        })
    }

    return (
        <div>
            <MyNewButton onClick={openModal}>&#43; neues Eisenbahnverkehrsunternehmen</MyNewButton>
            <ReactModal isOpen={showModal} className="modal">
                <MyModalCloseButton onClick={closeModal}>&#10007; </MyModalCloseButton>
                <MyModalForm onSubmit={submitForm}>
                    <h3>Neues Evu:</h3>
                    {attributes.map((column, index) => {
                        return (
                            <MyModalContentRow key={index}>
                                {<label>{`${column.Header}: `}
                                    <MyModalContentTextInput name={column.accessor} onChange={changingInput} required />
                                </label>}
                            </MyModalContentRow>
                        )
                    })}
                    <MyModalButtons>
                        <MySaveButton type="submit">Speichern</MySaveButton>
                        <MyCancelButton onClick={closeModal}>Abbruch</MyCancelButton>
                    </MyModalButtons>
                </MyModalForm>
            </ReactModal>
        </div>
    )
}